<template>
  <div class="section-header" :class="[position]">
    <div class="section-header-wrapper">
      <h3 class="main-title">{{ mainTitle }}</h3>
      <h4 class="sub-title">{{ subTitle }}</h4>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      mainTitle: String,
      subTitle: String,
      align: {
        default: "center"
      }
    },
    data() {
      return {
        assets: {
          // icon: require("../../assets/img/banner/bannerAsset.png")
        }
      }
    },
    computed: {
      position() {
        return `align-${this.align}`;
      }
    }
  };
</script>

<style lang="scss">
  .section-header {
    display: flex;
    justify-content: center;
    height: 70px;

    &.align-left {
      justify-content: left;

      .section-header-wrapper {
        padding-left: 30px;
        transform: translateX(0);
      }
    }

    .section-header-wrapper {
      display: flex;
      flex-direction: column;
      align-items: left;
      justify-content: center;
      padding-left: 30px;
      height: 100%;
      background: url("../../assets/img/icons/line_dot.png") no-repeat left center;
      box-sizing: border-box;
      transform: translateX(-30px);
    }
    
    .main-title {
      color: #333;
      font-size: 30px;
    }
    
    .sub-title {
      color: #999;
    }
  }
</style>